import React from "react";
import {Button, Row, Col, Glyphicon, FormControl, Dropdown} from "react-bootstrap";
import InlineForm from '../Elements/FromGroup/InlineForm'
import AscComponent from "../../components/AscComponent";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import Favi from "../Elements/Favi/Favi"
import InboundGroupModal from "./InboundGroupModal";
import * as GlobalConst from "../../components/AscConstants";
import AscConfirm from "../../components/Modal/AscConfirm";
import moment from "moment";
import { MultiSelect } from "react-multi-select-component";
import { CSVLink } from "react-csv";
import NumberSettingInfoDiagram from '../../components/Modal/NumberSettingInfoDiagram';

export default class InboundGroup extends AscComponent {
    constructor(props) {
        super(props);
        // CSVデフォルトヘッダー（不変）をコンストラクタ先頭で定義
        this.csvDefaultHeader = [
            // 会社名
            {
                label: this.props.langText.Body.CompanyName,
                key: "CompanyName"
            },
            // 拠点名
            {
                label: this.props.langText.Body.DepartmentName,
                key: "DepartmentName"
            },
            // フロア名
            {
                label: this.props.langText.Body.FloorName,
                key: "FloorName"
            },
            // グループ名
            {
                label: this.props.langText.Body.GroupName,
                key: "GroupName"
            },
            // 内線番号数
            {
                label: this.props.langText.Body.ExtensionNumberNum,
                key: "ExtensionNumberNum"
            }
        ];
        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            filtered: [],
            pages: null,
            loading: false,

            // modal item
            show: false,
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: "",
            confirmValue: "",
            modalType: null,

            // select item
            companySelect: [],
            departmentSelect: [],
            floorSelect: [],
            extensionNumberSelect: [],
            inboundGroupTypeSelect: this.getSelectOption(
                'inbound_group_type',
                this.props.langText.SelectOption
            ),
            csvDepartmentSelect: [],
            csvFloorSelect: [],

            // data item
            inbound_group_info_id: "",
            company_id: "",
            company_name: "",
            department_id: "",
            department_name: "",
            floor_id: "",
            floor_name: "",
            group_name: "",
            group_type: "",
            group_type_org: "",
            extension_number: [],

            // button_disabled
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load" : [],
                "floor_load" : []
            },

            csv_company_id: this.props.userInfo.company_id,
            csv_department_id: [],
            csv_floor_id: [],

            // 番号設定構成図関連
            showResourceMap: false,
            resourceMapLoading: false,
            resourceMapData: null,
            csvData: [],
            csvHeader: [...this.csvDefaultHeader],
            validationMessage: []
        };
        this.floor_load_flag = false;

        // csvデータ作成準備
        this.csvLink = React.createRef();
    }

    componentDidMount = async() => {
        // 追加確認ポップアップ表示の対象画面であるか
        try {
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    /**
     * 番号設定構成図ボタンの表示可否判定
     * 外線番号管理・内線番号管理の閲覧権限を両方とも持っていればtrueを返す
     */
    hasRequiredNumberSettingReadAuthority = () => {
        try {
            const permissionList = (this.props.userInfo && this.props.userInfo.permission_json_data) ? this.props.userInfo.permission_json_data : [];
            const required = ["ExternalNumber", "ExtensionNumber"];
            return required.every(controllerId => {
                const p = permissionList.find(row => row.controller_id === controllerId);
                return p && p.read;
            });
        } catch (e) {
            return false;
        }
    }

    getColumnsData() {
        let itemArr = [];

        itemArr.push({
            Header: this.props.langText.Body.Id,
            accessor: "id",
            filterable: false,
            width: this.props.boardWidth.id,
        });
        if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)){
            //oem権限以上の場合、会社名を表示
            itemArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: "cm13_departments.cm12_companies.company_name",
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.cm12_companies.company_name")} />
            });
        }
        if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)){
            //会社権限以上の場合、拠点名を表示
            itemArr.push({
                Header: this.props.langText.Body.DepartmentName,
                accessor: "cm13_departments.department_name",
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm13_departments.department_name")} />
            });
        }
        if (
            (this.props.systemParameters.SYSTEM_FLOOR_FLG === "Y" &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.system)) ||
            (this.props.userInfo.floor_flg &&
                this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department))
        ) {
            //システム権限または拠点管理権限のフロアありの場合、フロア名を表示
            itemArr.push({
                Header: this.props.langText.Body.FloorName,
                accessor: "cm13_departments.floor_name",
                Filter: () => (
                    <FormControl
                        onChange={e =>
                            this.onFilterChange(e.target.value, "cm13_departments.floor_name")
                        }
                    />
                ),
            });
        }
        itemArr.push({
            Header: this.props.langText.Body.GroupName,
            accessor: "inbound_group_name",
            Cell: data => {
                return ( <div title= {data.row._original.inbound_group_name}>
                        {data.row._original.inbound_group_name}
                    </div>
                );
            },
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "inbound_group_name")} />
        });
        itemArr.push({
            Header: this.props.langText.Body.ExtensionNumberNum,
            filterable: false,
            width: this.props.boardWidth.large,
            accessor: "ExtensionNumCount",
        });
        itemArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            width: this.props.boardWidth.smedium,
            Cell: data => {
                let rowData = [];

                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button
                            key={0}
                            bsSize="xsmall"
                            onClick={this.modalShow("update", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="pencil" />
                        </Button>
                    );
                } else {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize="xsmall"
                            onClick={this.modalShow("read", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="eye-open" />
                        </Button>
                    );
                }

                if (this.props.currentPermission.create) {
                    rowData.push(
                        <Button
                            key={1}
                            bsSize="xsmall"
                            onClick={this.modalShow("copy", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="copy"/>
                        </Button>
                    );
                }

                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button
                            key={2}
                            bsSize="xsmall"
                            onClick={this.modalShow("delete", data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="minus" />
                        </Button>
                    );
                }

                if (this.hasRequiredNumberSettingReadAuthority()) {
                    // 外線番号管理・内線番号管理の閲覧権限を両方持つ場合のみ、
                    // 番号設定構成図ボタンを表示
                    rowData.push(
                        <Button
                            key={3}
                            bsSize="xsmall"
                            onClick={event => this.showNumberSettingInfoDiagram(event, data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="info-sign" />
                        </Button>
                    );
                }
                return (
                    <Row className='text-center'>
                        {rowData}
                    </Row>
                )
            }
        });

        return itemArr;
    }

    modalshow_commonInit() {
        this.setState({
            buttondisabledArr: {
                "company_id" : [],
                "department_id" : [],
                "floor_id" : [],
                "department_load" : [],
                "floor_load" : []
            }
        });
    };

    common_buttondisabledLengthCheck = (param,switchdata) => {
        switch (switchdata)
        {
            case `push`:
                if(this.state.buttondisabledArr[param].length === 0)
                {
                    this.state.buttondisabledArr[param].push("dataset");
                }
            break;
            case `pop`:
                this.state.buttondisabledArr[param].pop();
            break;
            default:
                console.log("common_buttondisabledLengthCheck_switchErr");
            break;
        }
    }

    modalShow = (modalType, param) => async event => {
        try{
            event.preventDefault();

            this.floor_load_flag = false;

            this.modalshow_commonInit();

            let setData = {
                inbound_group_info_id: "",
                company_id: "",
                company_name: "",
                department_id: "",
                department_name: "",
                group_name: "",
                group_type: this.state.inboundGroupTypeSelect[2].value,
                group_type_org:"",
                extension_number: [],
                companySelect: [],
                departmentSelect: [],
                extensionNumberSelect: [],
                floor_id: ""
            };

            if (param) {
                setData.inbound_group_info_id = param.id
                    ? param.id
                    : setData.inbound_group_info_id;
                setData.company_id = param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.id
                    ? param.cm13_departments.cm12_companies.id
                    : setData.company_id;
                setData.company_name = param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.company_name
                    ? param.cm13_departments.cm12_companies.company_name
                    : setData.company_name;
                setData.floor_flg = param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.floor_flg
                    ? param.cm13_departments.cm12_companies.floor_flg === "Y"
                    : null;
                setData.department_id = param.cm13_departments && param.cm13_departments.id
                    ? param.cm13_departments.id
                    : setData.department_id;
                setData.department_name = param.cm13_departments && param.cm13_departments.department_name
                    ? param.cm13_departments.department_name
                    : setData.department_name;
                setData.department_prefix = param.cm13_departments && param.cm13_departments.department_prefix
                    ? param.cm13_departments.department_prefix
                    : setData.department_prefix;
                setData.floor_id = param.cm13_departments && param.cm13_departments.cm12_companies
                && param.cm13_departments.cm12_companies.floor_flg === "Y" && param.cm13_departments && param.cm13_departments.id
                    ? param.cm13_departments.id
                    : "";
                setData.floor_name = param.cm13_departments && param.cm13_departments.floor_name
                    ? param.cm13_departments.floor_name
                    : setData.floor_name;
                setData.floor_flg = param.cm13_departments && param.cm13_departments.cm12_companies && param.cm13_departments.cm12_companies.floor_flg
                    ? param.cm13_departments.cm12_companies.floor_flg === "Y"
                    : null;
                setData.group_name = param.inbound_group_name
                    ? param.inbound_group_name
                    : setData.group_name;
                setData.group_type = param.inbound_type
                    ? param.inbound_type
                    : setData.group_type;
                setData.group_type_org = param.inbound_type
                    ? param.inbound_type
                    : setData.group_type;
                setData.extension_number = param.cm51_extension_numbers
                    ? param
                        .cm51_extension_numbers
                        .map(row => {
                            return row.id;
                        })
                    : setData.extension_number;
            } else {
                if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                    setData.floor_flg = this.props.userInfo.floor_flg;
                    setData.company_id = this.props.userInfo.company_id;
                    setData.company_name = this.props.userInfo.company_name;
                }

                if (this.props.currentPermission.scope_code === GlobalConst.SCOPE_OBJECT.department.name) {
                    //新規作成時に拠点情報とフロア選択肢をセットする
                    setData.department_id = this.props.userInfo.department_id
                    setData.department_name = this.props.userInfo.department_name
                    this.departmentSelectChanged({
                        company_id: setData.company_id,
                        department_prefix: this.props.userInfo.department_prefix,
                    });
                }

                if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.floor)) {
                    setData.department_id = this.props.userInfo.department_id
                    setData.department_name = this.props.userInfo.department_name
                    setData.floor_id = this.props.userInfo.department_id
                    setData.floor_name = this.props.userInfo.floor_name
                }
            }

            if (modalType === "copy" && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)) {
                //グループ名は重複不可のため初期表示は空白にする
                setData.group_name = "";

                //フロアがある場合拠点idとprefix再設定
                if(setData.floor_flg){
                    setData.floor_id = param.cm13_departments.id;
                    const parentDepartment = await this.getParentDepartment(
                        param.cm13_departments.cm12_companies.id,
                        param.cm13_departments.department_prefix
                    );
                    setData.department_id = parentDepartment.data.id;
                    setData.department_prefix = parentDepartment.data.department_prefix;
                }

                this.departmentSelectChanged({
                    company_id: setData.company_id,
                    department_prefix: setData.department_prefix,
                });
            }

            this.getCompanySelect();
            this.getDepartmentSelect(setData);

            if (setData.company_id !== "" && setData.department_id !== "" && setData.group_type !== "") {
                this.getExtensionNumberSelect({
                    department_id: setData.floor_flg ? setData.floor_id : setData.department_id,
                    group_type: setData.group_type
                });
            }

            setData.isSetShowAddingConfirmationPopup =
                setData.company_id !== ""
                    ? await this.getIsShowAddingConfirmationPopup(setData.company_id)
                    : false
            ;

            this.setState(setData);
            this.setState({show: true, showConfirm: false, confirmMemo: "", confirmValue: "", modalType});
        }catch(err){
            this.showErrorObjectMesssage(err);
            this.reactTableRefresh();
        }
    };

    async onSelectChange(event, param) {
        super.onSelectChange(event, param);
        let value = (event && event.value) ? event.value : "";
        const floor_flg = (event && event.floor_flg) ? event.floor_flg === "Y" : this.state.floor_flag;
        const department_prefix = (event && event.department_prefix) ? event.department_prefix : "";

        try {
            switch (param) {
                case "company_id":
                    this.setState({department_id: "", floor_flg, extension_number: [], extensionNumberSelect: []});
                    this.getDepartmentSelect({company_id: value, floor_flg});
                    this.departmentSelectChanged({company_id: value, department_prefix});
                    this.setState({
                        isSetShowAddingConfirmationPopup : await this.getIsShowAddingConfirmationPopup(value)
                    })
                    break;

                case "department_id":
                    if (this.state.floor_flg) {
                        this.floor_load_flag = true;
                        this.departmentSelectChanged({company_id: this.state.company_id, department_prefix});
                    }
                    //内線を一覧取得のため、breakせずに処理を継続させる
                case "floor_id":
                    this.setState({extension_number: []});
                    let department_id = value,
                        group_type = this.state.group_type;

                    this.getExtensionNumberSelect({department_id, group_type});
                    break;

                case 'csv_company_id':
                    this.setState({
                        csv_department_id: [],
                        csv_floor_id: [],
                        floor_flg,
                        validationMessage: []
                    });
                    this.csvCompanySelectChanged(true, {company_id: value});
                    this.setCommonDepartmentSelect(value, floor_flg);
                    break;

                default:
                    break;

            }
        } catch(err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    onRadioChange(event, param) {
        super.onRadioChange(event, param);
        let value = (event && event.target && event.target.value) ? event.target.value : "";

        if (param === "group_type") {
            // this.setState({extension_number: []});
            let department_id = this.state.floor_id || this.state.department_id,
                group_type = value;
            this.getExtensionNumberSelect({department_id, group_type});
        }
    }

    /**
     * 拠点の選択肢をセットする
     * @param {string} company_id
     * @param {boolean} floor_flg
     */
    csvCompanySelectChanged = async ({company_id, floor_flg}) => {
        if(company_id)
        {
            this.common_buttondisabledLengthCheck(`department_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`department_load`,`pop`);
        }
        try {
            const res = await this.ascAxios('post', `Common/departmentSelect`, {
                container: this.reactContainerPath,
                company_id,
                floor_flg
            });
            if(this.state.company_id)
            {
                this.common_buttondisabledLengthCheck(`department_id`,`push`);
                this.common_buttondisabledLengthCheck(`department_load`,`pop`);
            }
            else
            {
                this.common_buttondisabledLengthCheck(`department_id`,`pop`);
            }
            this.setState({departmentSelect: res.data});
        } catch (err) {
            alert(this.getErrorString(err.response.data));
        }
    }

    getCompanySelect = () => {
        this
            .ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath})
            .then(res => {
                this.common_buttondisabledLengthCheck(`company_id`,`push`);
                this.setState({companySelect: res.data});
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data));
            });
    };

    getDepartmentSelect = ({company_id, floor_flg}) => {
        if(company_id)
        {
            this.common_buttondisabledLengthCheck(`department_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`department_load`,`pop`);
        }
        this.ascAxios('post', `Common/departmentSelect`, {
            container: this.reactContainerPath,
            company_id,
            floor_flg
        }).then(res => {
            if(this.state.company_id)
            {
                this.common_buttondisabledLengthCheck(`department_id`,`push`);
                this.common_buttondisabledLengthCheck(`department_load`,`pop`);
            }
            else
            {
                this.common_buttondisabledLengthCheck(`department_id`,`pop`);
            }
            this.setState({departmentSelect: res.data});
        }).catch(err => {
            alert(this.getErrorString(err.response.data));
        });
    };

    /**
 * 親拠点情報を取得する
 * @param {string} company_id 
 * @param {string} department_prefix 
 */
    getParentDepartment = async(company_id, department_prefix) => {
        try {
            const parentDepartment = await this.ascAxios("post", `Common/getParentDepartment`, {
                company_id: company_id,
                department_prefix: department_prefix.slice(0, 2),
            });
            return parentDepartment;
        } catch (err) {
            throw new Error(err);
        }
    }

    getExtensionNumberSelect = ({department_id, group_type}) => {
        this
            .ascAxios(
                'post',
                `${this.reactContainerPath}/extensionNumberSelect`,
                {department_id, group_type}
            )
            .then(res => {
                let extension_number_setup = [];
                let extensionNumberSelectData = res.data.cm51_extension_numbers.map(row => {
                    let labeldata = <div>
                                        {row.label}
                                        <Favi
                                            className="pull-right fa-fw fa-icon fa-icon-static"
                                            icon={row.type}
                                        />
                                    </div>;
                    this.state.extension_number.map(extension_data => {
                        if (row.value == extension_data) {
                            extension_number_setup.push(extension_data);
                        }
                    });

                    return {
                        search: row.label,
                        label: labeldata,
                        value: row.value
                    }

                });
                this.setState({extension_number: extension_number_setup});
                this.setState({extensionNumberSelect: extensionNumberSelectData});
            })
            .catch(err => {
                alert(this.getErrorString(err.response.data));
            });
    };

    /**
     * ドロップダウン表示時に会社名の選択肢をselectBoxにセット
     * @param {string} company_id
     * @param {boolean} floor_flg
     */
    getDefaultSelectData = async ({company_id, floor_flg}) => {
        try {
            const res = await this.ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath});
            this.csvCompanySelectChanged({company_id, floor_flg});

            this.setState({
                companySelect: res.data
            });
            this.common_buttondisabledLengthCheck(`company_id`,`push`);
        } catch (err) {
            alert(this.getErrorString(err.response.data))
        }
    }

    /**
     * フロアの選択肢をセット
     * @param {*}
     */
    departmentSelectChanged = ({company_id, department_prefix}) => {
        this.setState({
            floor_id: ""
        });

        if(this.floor_load_flag === true && department_prefix && company_id)
        {
            this.common_buttondisabledLengthCheck(`floor_load`,`push`);
        }
        else
        {
            this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
        }

        this.ascAxios('post', `Common/floorSelect`, {company_id, department_prefix})
        .then(res => {
            if(department_prefix)
            {
                this.common_buttondisabledLengthCheck(`floor_id`,`push`);
                this.common_buttondisabledLengthCheck(`floor_load`,`pop`);
                this.floor_load_flag = false;
            }
            else
            {
                this.common_buttondisabledLengthCheck(`floor_id`,`pop`);
            }
            this.setState({
                floorSelect: res.data,
            });
        })
        .catch(err => {
            alert(this.getErrorString(err.response.data))
        })
    }

    onClickHandle = modalType => event => {
        let {
            inbound_group_info_id,
            company_id,
            department_id,
            floor_id,
            group_name,
            group_type,
            extension_number,
            isSetShowAddingConfirmationPopup,
            confirmMemo
        } = this.state;

        if (
            !this.isTargetShowAddingConfirmationPopup ||
            !isSetShowAddingConfirmationPopup
        ) {
            if (!window.confirm(`${this.createPopupMessage(
                // 追加確認ポップアップ表示設定がOFFである場合、
                // 通常の確認ポップアップを表示
                this.props.langText.Body.InboundGroupName,
                group_name,
                modalType
            )}`)) {
                return;
            }
        }

        switch (modalType) {
            case "insert":
            case "copy":
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/insert`, {
                        company_id,
                        department_id: floor_id || department_id,
                        group_name,
                        group_type,
                        extension_number,
                        confirmMemo
                    })
                    .then(res => {
                        alert(
                            `${this.props.langText.Message.DataInsertSuccess}\r\n   ${this.props.langText.Body.GroupName}: ${res.data.group_name}\r\n   ${this.props.langText.Body.ExtensionNumberNum}: ${res.data.extension_count}`
                        );
                        this.reactTableRefresh();
                        this.setState({show: false});
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                        if (err.response.data.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({ show: false });
                        }
                    });
                break;

            case "update":
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/update`, {
                        company_id,
                        inbound_group_info_id,
                        department_id,
                        group_name,
                        group_type,
                        extension_number,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup
                    })
                    .then(res => {
                        alert(
                            this.props.langText.Message.DataUpdateSuccess
                        );
                        this.reactTableRefresh();
                        this.setState({show: false});
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                        if (err.response.data.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({ show: false });
                        }
                    });
                break;

            case "delete":
                this.blockUI();
                this
                    .ascAxios('post', `${this.reactContainerPath}/delete`, {
                        inbound_group_info_id,
                        group_name,
                        confirmMemo,
                        isSetShowAddingConfirmationPopup,
                        company_id, // データ変更時メール送信処理で使用
                        extension_number // データ変更時メール送信処理で使用
                    })
                    .then(res => {
                        alert(
                            this.props.langText.Message.DataDeleteSuccess
                        );
                        this.reactTableRefresh();
                        this.setState({show: false});
                    })
                    .catch(err => {
                        alert(this.getErrorString(err.response.data));
                        if (err.response.data.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({ show: false });
                        }
                    });
                break;

            default:
                alert(this.getErrorString({code: "modal"}));
        }
        this.setState({
            showConfirm: false  // 追加確認ポップアップも同時に閉じる
        });
    };

    validationHandle = param => {
        let nowState = null;
        let {
            company_id,
            department_id,
            floor_id,
            group_name
        } = this.state;

        switch (param) {
            case "company_id":
            case "department_id":
            case "floor_id":
            case "group_name":
                nowState = this.state[param]
                    ? null
                    : "error";
                break;

            case "insert":
            case "copy":
                nowState = (company_id && department_id && group_name);

                if (this.state.floor_flg) {
                    nowState = (nowState && floor_id)
                }
                break;
            case "update":
            case "delete":
                nowState = (company_id && department_id && group_name);
                break;

            default:

        }

        return nowState;
    };

    setCsvSelect = () => {
        //csv出力権限がある場合、会社・拠点・フロアリストを取得
        if (this.props.currentPermission.export && !this.state.modalType) {
            this.getDefaultSelectData({"company_id": this.props.userInfo.company_id}, {"floor_flg": this.props.userInfo.floor_flg});
            this.setCommonDepartmentSelect(this.props.userInfo.company_id, this.props.userInfo.floor_flg);
        }
    }

    createCsvData = async () => {
        let {
            csv_company_id,
            csv_department_id,
            csv_floor_id,
            csvDepartmentSelect,
            csvFloorSelect
        } = this.state;

        try {
            this.blockUI();
            this.setState({ loading: true });
            let reqBody = {
                sorted: [ { id: 'id', desc: true } ],
                filtered: []
            }

            // 会社IDの追加（配列で厳密一致にする）
            if (csv_company_id) {
                const companyIds = Array.isArray(csv_company_id) ? csv_company_id : [csv_company_id];
                reqBody.filtered.push({
                    id: 'cm13_departments.cm12_companies.id', 
                    value: companyIds
                });
            }

            //全選択以外の場合だけcm13のフィルターを指定
            let csv_department_ids = csv_department_id.map(row => {return row.value});
            if ((csv_department_id.length !== csvDepartmentSelect.length) ||
                (csv_floor_id.length !== csvFloorSelect.length)) {
                if ((csv_floor_id && csv_floor_id.length > 0)) {
                    csv_floor_id.forEach(row => {
                        csv_department_ids.push(row.value);
                    });
                }
                reqBody.filtered.push({
                    id: 'cm13_departments.id',
                    value: csv_department_ids
                });
            }

            const result = await this.ascAxios(
                "post",
                `${this.reactContainerPath}/board`,
                reqBody
            );

            let csvData = [];
            if (result.data.rows.length > 0) {
                for (const row of result.data.rows) {
                    let resultRow = {
                        CompanyName: row && row.cm13_departments && row.cm13_departments.cm12_companies && row.cm13_departments.cm12_companies.company_name 
                            ? row.cm13_departments.cm12_companies.company_name : "",
                        DepartmentName: row && row.cm13_departments && row.cm13_departments.department_name && row.cm13_departments.department_name !== "" 
                            && row.cm13_departments.department_name !== undefined && row.cm13_departments.department_name !== null
                            ? row.cm13_departments.department_name.toString() : "",
                        FloorName: row && row.cm13_departments && row.cm13_departments.floor_name && row.cm13_departments.floor_name !== "" 
                            && row.cm13_departments.floor_name !== undefined && row.cm13_departments.floor_name !== null
                            ? row.cm13_departments.floor_name.toString() : "",
                        GroupName: row && row.inbound_group_name 
                            ? row.inbound_group_name : "",
                        ExtensionNumberNum: row && row.cm51_extension_numbers 
                            ? row.cm51_extension_numbers.length.toString() : "0"
                    }
                    csvData.push(resultRow);
                }
            }

            let header = [...this.csvDefaultHeader];
            if (csv_floor_id.length === 0) {
                header = header.filter(item => item.key !== "FloorName");
            }

            this.setState({
                csvData,
                csvHeader: header,
                loading: false
            });

            if (csvData.length === 0) {
                return this.showErrorObjectMesssage({ message: "Download_Failed" });
            } else {
                // アクセスログ保存（CSVダウンロード）
                try {
                    let company_name = this.props.userInfo.company_name;
                    if (csv_company_id && this.state.companySelect && this.state.companySelect.length > 0) {
                        const company = this.state.companySelect.find(row => row.value === csv_company_id);
                        company_name = company ? company.label : company_name;
                    }
                    this.saveAccessLogs({
                        resource: `${this.reactContainerPath}/csvDownload`,
                        body: {
                            category: "inbound_group",
                            file_name: this.getCsvFileName(),
                            company_id: csv_company_id,
                            company_name,
                            department_ids: (csv_department_id || []).map(r => r.value),
                            floor_ids: (csv_floor_id || []).map(r => r.value),
                            rows: csvData.length
                        }
                    });
                } catch (e) {
                    // ログ保存失敗は処理続行
                    console.error(e);
                }

                return this.csvLink.current.link.click();
            }
        } catch (err) {
            this.setState({ loading: false });
            this.showErrorObjectMesssage(err);
        } finally {
            this.unblockUI();
        }
    }

    onMultiSelectChange = async (event, param) => {
        super.onMultiSelectChange(event, param);
        let value_arr = (event.length > 0) ? [] : "";

        event.forEach((row, key) => {
            value_arr[key] = row['value'];
        });

        switch (param) {
            case "csv_department_id":
                await this.setCommonFloorSelect(value_arr);
                this.setState({[param]: event});
                await this.getCsvSelectValidationCheck(event, param);
                break;
            case "csv_floor_id":
                this.setState({[param]: event});
                await this.getCsvSelectValidationCheck(event, param);
                break;
            default:
                break;
        }
    }

    getCsvFileName() {
        const company_name = this.state.csv_company_id && this.state.companySelect.length > 0 
            && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)
            ? this.state.companySelect.find(row => row.value === this.state.csv_company_id).label
            : this.props.userInfo.company_name;

        const now_time = moment().utc().add(9, "h").format("YYYYMMDDHHmmss");
        const file_name = company_name + "_" + this.props.langText.Body.ExtensionNumberGroupList
            + "_" + now_time + ".csv";

        return file_name;
    }

    setCommonDepartmentSelect = async (company_id, floor_flg) => {
        try {
            let departmentList = await this.ascAxios("post", `Common/departmentSelect`, {
                container: this.reactContainerPath,
                company_id: company_id,
                floor_flg
            });
            this.setState({ 
                csv_department_id: departmentList.data || [],
                csvDepartmentSelect: departmentList.data || [] 
            });
            let departmentId = [];
            if(this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)){
                departmentId = departmentList.data.map(row => {return row.value});
            } else {
                departmentId = [this.props.userInfo.parent_department_id]
            }
            this.setCommonFloorSelect(departmentId);
        } catch (err) {
            this.showErrorObjectMesssage(err);
        }
    }

    setCommonFloorSelect = async (departmentIds) => {
        try {
            let floorList = await this.ascAxios("post", `Common/getFloorsByDepartmentIds`, {
                container: this.reactContainerPath,
                departmentIds
            });
            this.setState({
                csv_floor_id: floorList.data || [],
                csvFloorSelect: floorList.data || [],
            });
        } catch (err) {
            this.showErrorObjectMesssage(err);
        }
    };

    getCsvSelectValidationCheck = (event, param) => {
        let {
            csv_floor_id,
            floorSelect,
            validationMessage
        } = this.state;

        let message = [];

        const departmentNotSelected = this.sprintf(this.props.langText.Message.NoSelected, this.props.langText.Body.Department);
        const floorNotSelected = this.sprintf(this.props.langText.Message.NoSelected, this.props.langText.Body.Floor);
        
        switch (param) {
            case 'csv_department_id':
                //拠点が選択されてない場合、拠点エラーメッセージ追加
                if (event.length === 0) {
                    message.push(departmentNotSelected);
                //拠点が1個以上選択されてない場合、拠点エラーメッセージ除外
                } else if (event.length > 0) {
                    message = validationMessage.filter(row => row !== departmentNotSelected);
                    //フロアの選択肢がない場合、もしくはフロア選択肢があってフロアが1個以上選択されている場合はフロアエラーメッセージ除外
                    if (floorSelect.length === 0 || (floorSelect.length > 0 && csv_floor_id.length > 0)) {
                        message = message.filter(row => row !== floorNotSelected);
                    } 
                }
                break;
            case 'csv_floor_id':
                //フロアが選択されてない場合、フロアエラーメッセージ追加
                if (event.length === 0) {
                    message.push(floorNotSelected);
                //フロアが1個以上選択されてない場合、フロアエラーメッセージ除外
                } else if (event.length > 0) {
                    message = validationMessage.filter(row => row !== floorNotSelected);
                }
                break;
            default:
                break;
        }
        const set = new Set(message);
        this.setState({
            validationMessage : [...set]
        });
    }

    /**
     * 番号設定構成図を表示する
     * @param {Event} event
     * @param {Object} rowData 選択された行のデータ
     */
    showNumberSettingInfoDiagram = async (event, rowData) => {
        try {
            event.preventDefault();

            // モーダルを開く
            this.setState({
                showResourceMap: true,
                resourceMapLoading: true,
                resourceMapData: null
            });

            // 内線グループの詳細情報を取得
            const groupId = rowData.id;
            const groupName = rowData.inbound_group_name;

            // 番号設定構成図データを取得
            const resourceMapResult = await this.ascAxios("post", "/Common/getInfosForNumberSettingInfoDiagram", {
                type: "inbound_group",
                baseItemId: groupId
            });

            const externalNumbers = resourceMapResult.data.externalNumbers || [];
            const extensionNumbers = resourceMapResult.data.extensionNumbers || [];

            const resourceMapData = {
                inboundGroup: {
                    inbound_group_id: groupId,
                    inbound_group_name: groupName
                },
                externalNumbers: externalNumbers,
                extensionNumbers: extensionNumbers,
                companyName: this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)
                    ? rowData.cm13_departments.cm12_companies.company_name
                    : this.props.userInfo.company_name
            };

            this.setState({
                resourceMapData,
                resourceMapLoading: false
            });
        } catch (err) {
            this.showErrorObjectMesssage(err);
        }
    }

    render() {
        return (
            <div className="ExternalNumber">
                <Row>
                    <Col xs={12} md={12}>
                        {this.props.currentPermission.create && (
                            <Button
                                id="inboundGroup-insert"
                                className="table-button"
                                bsStyle="default"
                                bsSize="sm"
                                onClick={this.modalShow('insert')}
                            >
                                {this.props.langText.Body.InsertTitle}
                            </Button>
                        )}
                        {this.props.currentPermission.export && 
                            <Col className="pull-right">
                                <div>
                                    <Dropdown
                                        onClick={e => {if (!e.currentTarget.className.includes("open")) this.setCsvSelect();}}>
                                        <Dropdown.Toggle 
                                            className='table-button'
                                            bsStyle='default'
                                            bsSize='sm'>
                                            {this.props.langText.Body.SettingInfoDownload}
                                        </Dropdown.Toggle>
                                        <SettingMenu bsRole="menu">
                                            <Col>
                                                <Col xs={12} sm={12} md={12} lg={12} className="margin-top-10 margin-bottom-07">
                                                    <Col xs={2} sm={2} md={3} lg={3} className="text-align-left margin-top-05">
                                                        {this.props.langText.Body.CompanyName}
                                                    </Col>
                                                    {this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)
                                                        ?
                                                        <Col xs={10} sm={10} md={9} lg={9}>
                                                            <InlineForm
                                                                key = "csv_company_id"
                                                                controlId = "csv_company_id"
                                                                type = "select"
                                                                onChange = {e => this.onSelectChange(e, "csv_company_id")}
                                                                options = {this.state.companySelect}
                                                                value = {this.state.csv_company_id}
                                                                placeholder = {!this.state.buttondisabledArr.company_id[0] 
                                                                    ? <Glyphicon glyph="refresh" className="spinning"/> : this.props.langText.SelectOption.Placeholder}
                                                                isDisabled = {!this.state.buttondisabledArr.company_id[0]}/>
                                                        </Col>
                                                        :
                                                        <Col xs={10} sm={10} md={9} lg={9} className="padding-top-05 padding-left-30">
                                                            {this.props.userInfo.company_name}
                                                        </Col>
                                                    }
                                                </Col>
                                                {((this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company) && this.state.csvDepartmentSelect.length > 0) 
                                                    || !this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) &&
                                                    <Col xs={12} sm={12} md={12} lg={12} className="margin-top-03 margin-bottom-07">
                                                        <Col xs={2} sm={2} md={3} lg={3} className="text-align-left margin-top-05">
                                                            {this.props.langText.Body.DepartmentName}
                                                        </Col>
                                                        {this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company) 
                                                            ?
                                                            <Col xs={10} sm={10} md={9} lg={9}>
                                                                <Col xs={12} sm={12} md={12} lg={12}>
                                                                    <MultiSelect
                                                                        hasSelectAll={true}
                                                                        options={this.state.csvDepartmentSelect}
                                                                        value = {this.state.csv_department_id}
                                                                        onChange={e => this.onMultiSelectChange(e, "csv_department_id")}
                                                                        filterOptions={this.createFilterOptions("csvDepartmentSelect", "csv_department_id")}
                                                                        overrideStrings={{
                                                                            selectSomeItems: this.props.langText.SelectOption.Placeholder,
                                                                            allItemsAreSelected: this.props.langText.Body.AllSelected,
                                                                            selectAll: this.props.langText.MultiSelect.AllSelect,
                                                                            search: this.props.langText.Body.Search,
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <Col xs={10} sm={10} md={9} lg={9} className="padding-top-05 padding-left-30">
                                                                {this.props.userInfo.department_name ? this.props.userInfo.department_name : ""}
                                                            </Col>
                                                        }
                                                    </Col>
                                                }{((this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) 
                                                    && (this.props.userInfo.floor_flg || this.state.floor_flg) && (this.state.csvFloorSelect.length > 0)) 
                                                    || (!this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department) && this.props.userInfo.floor_flg)) &&
                                                    <Col xs={12} sm={12} md={12} lg={12} className="margin-top-03 margin-bottom-07">
                                                        <Col xs={2} sm={2} md={3} lg={3} className="text-align-left margin-top-05">
                                                            {this.props.langText.Body.FloorName}
                                                        </Col>
                                                        {this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)
                                                            ?
                                                            <Col xs={10} sm={10} md={9} lg={9}>
                                                                <Col xs={12} sm={12} md={12} lg={12}>
                                                                    <MultiSelect
                                                                        hasSelectAll={true}
                                                                        options={this.state.csvFloorSelect}
                                                                        value = {this.state.csv_floor_id}
                                                                        onChange={e => this.onMultiSelectChange(e, "csv_floor_id")}
                                                                        filterOptions={this.createFilterOptions("csvFloorSelect", "csv_floor_id")}
                                                                        overrideStrings={{
                                                                            selectSomeItems: this.props.langText.SelectOption.Placeholder,
                                                                            allItemsAreSelected: this.props.langText.Body.AllSelected,
                                                                            selectAll: this.props.langText.MultiSelect.AllSelect,
                                                                            search: this.props.langText.Body.Search,
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Col>
                                                            :
                                                            <Col xs={10} sm={10} md={9} lg={9} className="padding-top-05 padding-left-30">
                                                                {this.props.userInfo.floor_name ? this.props.userInfo.floor_name : ""}
                                                            </Col>
                                                        }
                                                    </Col>
                                                }{<Col xs={10} sm={10} md={9} lg={9}>
                                                    <label className="margin-top-05 margin-left-1 search-message">
                                                        {this.state.validationMessage.map((row, key) =>
                                                            <p key={key}>{row}</p>
                                                        )}
                                                    </label>
                                                </Col>}
                                                <Col xs={12} sm={12} md={12} lg={12} 
                                                    className="margin-top-07 margin-bottom-07 text-align-center margin-right-1">
                                                    <Col className="pull-right margin-right-15">
                                                        <Button
                                                            className='table-button'
                                                            bsStyle='default'
                                                            bsSize='sm'
                                                            onClick={this.createCsvData}
                                                            disabled = {this.state.validationMessage.length > 0}>
                                                            {this.props.langText.Body.CSVExport}
                                                        </Button>
                                                        <CSVLink
                                                            data={this.state.csvData}
                                                            headers={this.state.csvHeader}
                                                            filename={this.getCsvFileName()}
                                                            className="csv-download-link-format hidden"
                                                            ref={this.csvLink}
                                                        />
                                                    </Col>
                                                </Col>
                                            </Col>
                                        </SettingMenu>
                                    </Dropdown>
                                </div>
                            </Col>
                        }
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = "manual"
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable = {true}
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}/>
                    </Col>
                </Row>

                <InboundGroupModal
                    state = {this.state}
                    propSetState = {this.propSetState}
                    langText = {this.props.langText}
                    charaLimit = {this.props.charaLimit}
                    onClick = {this.onClickHandle}
                    onClickConfirm = {this.onClickConfirm}
                    onTextChange_Limit = {this.onTextChange_Limit}
                    onSelectChange = {this.onSelectChange}
                    onMultiSelectChange = {this.onMultiSelectChange}
                    onCheckBoxChange = {this.onCheckBoxChange}
                    onRadioChange = {this.onRadioChange}
                    validationHandle = {this.validationHandle}
                    getScopeGreaterEqual = {this.getScopeGreaterEqual}
                    isTargetShowAddingConfirmationPopup = {this.isTargetShowAddingConfirmationPopup}
                    />
                {
                    this.isTargetShowAddingConfirmationPopup &&
                    this.state.isSetShowAddingConfirmationPopup &&
                    <AscConfirm
                        state={
                            {
                                ...this.state,
                                show: this.state.showConfirm || false // showConfirmをshowに変換
                            }
                        }
                        key={this.state.modalType}
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        onClick = {this.onClickHandle}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        confirmKey = {this.props.langText.Body.InboundGroupName}
                        confirmKeyItem = {this.state.group_name}
                        sprintf = {this.sprintf}
                        customBtn1Func = {this.onClickConfirm}
                    >
                    </AscConfirm>
                }

                {/* 番号設定構成図モーダル */}
                <NumberSettingInfoDiagram
                    state={this.state}
                    langText={this.props.langText}
                    propSetState={this.propSetState}
                    sourceScreen="inbound"
                    ascAxios={this.ascAxios}
                    getScopeGreaterEqual={this.getScopeGreaterEqual}
                    boardWidth={this.props.boardWidth}
                    userInfo={this.props.userInfo}
                    tableClass="inbound-group-resource-map-table"
                    connectionLineClass="inbound-group-connection-lines"
                />
            </div>
        );
    }
}

class SettingMenu extends React.Component {

    render() {
        const { children } = this.props;

        return (
            <Dropdown.Menu className="dropdown-menu-right inboundGroup-dropdown-menu">
                {React.Children.toArray(children)}
            </Dropdown.Menu>
        );
    }
}